'use client';
var classes = {"root":"m_9bdbb667","panel":"m_df78851f","content":"m_4ba554d4","itemTitle":"m_8fa820a0","control":"m_4ba585b8","control--default":"m_6939a5e9","control--contained":"m_4271d21b","label":"m_df3ffa0f","chevron":"m_3f35ae96","icon":"m_9bd771fe","item":"m_9bd7b098","item--default":"m_fe19b709","item--contained":"m_1f921b3b","item--filled":"m_2cdf939a","item--separated":"m_9f59b069"};

export { classes as default };
//# sourceMappingURL=Accordion.module.css.mjs.map
